import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/images/logo_white.png'

const _withId = /*#__PURE__*/_withScopeId("data-v-776aff53")

_pushScopeId("data-v-776aff53")
const _hoisted_1 = {
  key: 0,
  class: "container"
}
const _hoisted_2 = /*#__PURE__*/_createVNode("img", {
  class: "logo",
  src: _imports_0
}, null, -1)
const _hoisted_3 = { class: "row" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode("New Job ")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("New Builder ")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("Export Loyalty Points ")
const _hoisted_7 = {
  key: 1,
  class: "container"
}
const _hoisted_8 = { style: {"display":"flex","justify-content":"center","align-items":"center","gap":"16px"} }
const _hoisted_9 = /*#__PURE__*/_createVNode("p", null, "Loading user data...", -1)
const _hoisted_10 = {
  key: 2,
  class: "responsive-flex"
}
const _hoisted_11 = { style: {"flex-grow":"1"} }
const _hoisted_12 = { class: "transactions" }
const _hoisted_13 = {
  key: 3,
  class: "container new-landing"
}
const _hoisted_14 = /*#__PURE__*/_createVNode("img", {
  class: "logo",
  src: _imports_0
}, null, -1)
const _hoisted_15 = /*#__PURE__*/_createVNode("h1", null, "Welcome to the PUL online portal", -1)
const _hoisted_16 = /*#__PURE__*/_createTextVNode("View Warehouse")
const _hoisted_17 = { class: "popup-content" }
const _hoisted_18 = /*#__PURE__*/_createTextVNode("Close")
const _hoisted_19 = /*#__PURE__*/_createTextVNode("Export")
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_f7_link = _resolveComponent("f7-link")
  const _component_f7_navbar = _resolveComponent("f7-navbar")
  const _component_f7_button = _resolveComponent("f7-button")
  const _component_f7_preloader = _resolveComponent("f7-preloader")
  const _component_PointsOverview = _resolveComponent("PointsOverview")
  const _component_SalespersonList = _resolveComponent("SalespersonList")
  const _component_TransactionsList = _resolveComponent("TransactionsList")
  const _component_f7_nav_right = _resolveComponent("f7-nav-right")
  const _component_f7_list_input = _resolveComponent("f7-list-input")
  const _component_f7_list = _resolveComponent("f7-list")
  const _component_f7_block = _resolveComponent("f7-block")
  const _component_f7_page = _resolveComponent("f7-page")
  const _component_f7_popup = _resolveComponent("f7-popup")

  return (_openBlock(), _createBlock(_component_f7_page, { name: "home" }, {
    default: _withId(() => [
      _createVNode(_component_f7_navbar, { class: "mobile-only" }, {
        left: _withId(() => [
          _createVNode(_component_f7_link, {
            class: "menu-btn",
            "icon-only": "",
            "icon-f7": "menu",
            "icon-size": "32",
            "panel-open": "left"
          })
        ]),
        _: 1
      }),
      (_ctx.isAdmin)
        ? (_openBlock(), _createBlock("div", _hoisted_1, [
            _hoisted_2,
            _createVNode("div", _hoisted_3, [
              _createVNode(_component_f7_button, {
                href: "/jobs/new",
                outline: ""
              }, {
                default: _withId(() => [
                  _hoisted_4
                ]),
                _: 1
              }),
              _createVNode(_component_f7_button, {
                href: "/builders/new",
                outline: ""
              }, {
                default: _withId(() => [
                  _hoisted_5
                ]),
                _: 1
              }),
              _createVNode(_component_f7_button, {
                "popup-open": "#export-loyalty-points-popup",
                outline: ""
              }, {
                default: _withId(() => [
                  _hoisted_6
                ]),
                _: 1
              })
            ])
          ]))
        : (_ctx.isLoadingUserData)
          ? (_openBlock(), _createBlock("div", _hoisted_7, [
              _createVNode("div", _hoisted_8, [
                _hoisted_9,
                _createVNode(_component_f7_preloader)
              ])
            ]))
          : (_ctx.canViewLoyaltyProgram)
            ? (_openBlock(), _createBlock("div", _hoisted_10, [
                _createVNode("div", _hoisted_11, [
                  _createVNode(_component_PointsOverview),
                  _createVNode(_component_SalespersonList)
                ]),
                _createVNode("div", _hoisted_12, [
                  _createVNode(_component_TransactionsList)
                ])
              ]))
            : (_openBlock(), _createBlock("div", _hoisted_13, [
                _hoisted_14,
                _hoisted_15,
                (_ctx.canViewWarehouse)
                  ? (_openBlock(), _createBlock(_component_f7_button, {
                      key: 0,
                      href: "/store",
                      fill: ""
                    }, {
                      default: _withId(() => [
                        _hoisted_16
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ])),
      (_ctx.isAdmin)
        ? (_openBlock(), _createBlock(_component_f7_popup, {
            key: 4,
            id: "export-loyalty-points-popup"
          }, {
            default: _withId(() => [
              _createVNode(_component_f7_page, null, {
                default: _withId(() => [
                  _createVNode("div", _hoisted_17, [
                    _createVNode(_component_f7_navbar, { title: "Export Loyalty Points" }, {
                      default: _withId(() => [
                        _createVNode(_component_f7_nav_right, null, {
                          default: _withId(() => [
                            _createVNode(_component_f7_link, { "popup-close": "" }, {
                              default: _withId(() => [
                                _hoisted_18
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_f7_list, {
                      form: "",
                      "no-hairlines": "",
                      style: {"margin":"0"}
                    }, {
                      default: _withId(() => [
                        _createVNode(_component_f7_list_input, {
                          outline: "",
                          label: "From",
                          type: "datepicker",
                          value: _ctx.fromDate,
                          "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => (_ctx.fromDate = $event))
                        }, null, 8, ["value"]),
                        _createVNode(_component_f7_list_input, {
                          outline: "",
                          label: "To",
                          type: "datepicker",
                          value: _ctx.toDate,
                          "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => (_ctx.toDate = $event))
                        }, null, 8, ["value"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_f7_block, {
                      strong: "",
                      "no-hairlines": "",
                      style: {"margin":"0"}
                    }, {
                      default: _withId(() => [
                        _createVNode(_component_f7_button, {
                          onClick: _ctx.exportTransactions,
                          preloader: "",
                          loading: _ctx.exportingTransactions,
                          fill: ""
                        }, {
                          default: _withId(() => [
                            _hoisted_19
                          ]),
                          _: 1
                        }, 8, ["onClick", "loading"])
                      ]),
                      _: 1
                    })
                  ])
                ]),
                _: 1
              })
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
})